import { html, css, LitElement } from 'lit';

class SingleMark extends LitElement {
  static properties = {
   
    svgFillColor: { type: String },
    svgHeight: { type: String },
    svgWidth: { type: String },
  };

  static styles = css`
     svg {
        height: 12px !important;
        width: 12px !important;
      }
  `
  render() {
    return html`
      <svg 
       width=${this.svgWidth || '13px'} height=${this.svgHeight || '13px'}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        fill="none"
        stroke=${this.svgFillColor || 'var(--text-primary-color)'}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier"><polyline points="2.75 8.75,6.25 12.25,13.25 4.75"></polyline></g>
      </svg>
    `;
  }
}

customElements.define('single-mark', SingleMark);
